import React from 'react';
import {
  Navbar,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap';
import { IoIosArrowForward } from 'react-icons/io';
import { NavLink as RRNavLink } from 'react-router-dom';
import { FaInstagram } from 'react-icons/fa';
import './Styles.css';

const TheFooter = (props) => {
  const data = props;
  const footerMenuRow = (text, toLink) => (
    <NavLink
      className="row m-0 pl-2 mx-1"
      style={{
        color: 'rgb(44,80,116)',
        width: '100%',
        borderBottom: 'solid 1px',
      }}
      activeClassName="active"
      tag={RRNavLink}
      to={toLink}
    >
      {text}
      <IoIosArrowForward style={{ float: 'right', marginTop: '5px' }} />
    </NavLink>
  );
  return (
    <>
      <footer style={{ background: 'rgb(205,226,233)', color: 'rgb(44,81,115)' }} className="footer">
        <div className="footer-top">
          <div className="container">
            <div className="footer-top-sp d-block d-lg-none">
              <br />
              {
              footerMenuRow('TERRAについて', '/about')
              }
              {
              footerMenuRow('ご購入流れ', '/purchase')
              }
              {
              footerMenuRow('よくあるご質問', '/faq')
              }
              {
              footerMenuRow('マイページ', data.isLoggedIn ? '/login' : '/mypage')
              }
              {
              footerMenuRow('会社概要', '/company')
              }
              {
              footerMenuRow('利用規約', '/terms')
              }
              {
              footerMenuRow('個人情報保護方針', '/privacy')
              }
              {
              footerMenuRow('特定商取引法に基づく表記', '/regulation')
              }
              <br />
              <br />
            </div>
            <Navbar className="row text-center text-lg-left" style={{ fontWeight: 'bold' }}>
              <div className="col-12 col-lg-4">
                <img
                  alt="株式会社TERRA"
                  src="/logo.png"
                  height="50"
                />
                <br />
                <br />
                <div className="address" style={{ padding: '0 1rem', color: 'rgb(44,81,115)' }}>
                  <span>〒 107-0051</span>
                  <br />
                  <span>東京都港区元赤坂 1-7-18</span>
                  <br />
                  <span>メットライフ元赤坂イースト 7F</span>
                  <br />
                  <span>TEL 03-6812-9104 &nbsp; FAX 03-6812-9105</span>
                  <br />
                  <span>フリーダイヤル &nbsp; 0120-406-510</span>
                </div>
              </div>
              <div className="col-12 col-lg-8 d-none d-lg-flex">
                <Nav style={{ padding: '10px' }} className="d-flex m-auto">
                  <div style={{ borderRight: 'solid 2px white' }}>
                    <NavItem className="mx-2">
                      <NavLink style={{ color: 'rgb(44,81,115)' }} exact activeClassName="active" tag={RRNavLink} to="/">全ての商品</NavLink>
                    </NavItem>
                  </div>
                  <div style={{ borderRight: 'solid 2px white' }}>
                    <NavItem className="mx-2">
                      <NavLink style={{ color: 'rgb(44,81,115)' }} exact activeClassName="active" tag={RRNavLink} to="/subscription">定期便</NavLink>
                    </NavItem>
                  </div>
                  <div style={{ borderRight: 'solid 2px white' }}>
                    <NavItem className="mx-2">
                      <NavLink style={{ color: 'rgb(44,81,115)' }} exact activeClassName="active" tag={RRNavLink} to="/single">単品</NavLink>
                    </NavItem>
                  </div>
                  <div style={{ borderRight: 'solid 2px white' }}>
                    <NavItem className="mx-2">
                      <NavLink style={{ color: 'rgb(44,81,115)' }} exact activeClassName="active" tag={RRNavLink} to="/company">会社概要</NavLink>
                    </NavItem>
                  </div>
                  <div>
                    <NavItem className="mx-2">
                      <NavLink style={{ color: 'rgb(44,81,115)' }} exact activeClassName="active" tag={RRNavLink} to="/contact">お問い合わせ</NavLink>
                    </NavItem>
                  </div>
                </Nav>
              </div>
              <a
                className="instagram d-none d-lg-block"
                href="https://instagram.com/terracoathikari?utm_medium=copy_link"
                target="blank"
                style={{
                  position: 'absolute',
                  height: '80px',
                  width: '80px',
                  borderRadius: '40px',
                  lineHeight: '80px',
                  textAlign: 'center',
                  right: '0',
                  background: 'rgb(44,81,115)',
                }}
              >
                <FaInstagram style={{ height: '50px', width: '50px', fill: 'white' }} />
              </a>
            </Navbar>
          </div>
        </div>
        <div className="footer-bottom" style={{ background: 'rgb(44,81,115)' }}>
          <div className="container">
            <div className="d-flex justify-content-between py-3">
              <div className="d-none d-lg-flex justify-content-start">
                <div className="px-1 align-self-center">
                  <NavLink className="align-items-center" style={{ color: 'White' }} exact activeClassName="active" tag={RRNavLink} to="/terms">利用規約</NavLink>
                </div>
                <div className="px-1">
                  <NavLink style={{ color: 'White' }} exact activeClassName="active" tag={RRNavLink} to="/privacy">個人情報保護方針</NavLink>
                </div>
                <div className="px-1">
                  <NavLink style={{ color: 'White' }} exact activeClassName="active" tag={RRNavLink} to="/regulation">特定商取引法に基づく表記</NavLink>
                </div>
              </div>
              <div className="align-self-center m-auto" style={{ color: 'White', padding: '0.5rem 1rem' }}>
                COPYRIGHT TERRA, ALL RIGHTS RECEIVED
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};
export default TheFooter;
